import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { SelectedVehicleContext } from '../../../contexts/vehicle/SelectedVehicleContext.ts';
import { postCreateMission } from '../../../queries/getVehicles.ts';
import { NodeType } from '../../../schema/Node.ts';
import { LoadingButton } from '../../ui/Button.tsx';

export function CreateMissionFromNode(props: Readonly<{ node: NodeType }>) {
  const { t } = useTranslation();
  const { selectedVehicle } = useContext(SelectedVehicleContext);
  const params = useParams() as { territorySlug: string };

  const createMissionMutation = useMutation({
    mutationFn: () => {
      if (props.node.id) {
        return postCreateMission(params.territorySlug, selectedVehicle?.id, {
          dispatch_destination_node_id: Number(props.node.id),
          activity: 3,
        });
      } else {
        throw new Error('Missing node dispatchId');
      }
    },
    onSuccess: () => {
      toast.success(
        `${t('vehicle.create-mission-toaster-success')} ${selectedVehicle?.display_identifier}`,
      );
    },
    onError: () => {
      toast.error(`${t('vehicle.create-mission-toaster-error')} ${selectedVehicle?.display_identifier}`);
    },
  });
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  async function createMission(e) {
    e.stopPropagation();
    createMissionMutation.mutate();
  }
  if (selectedVehicle?.id !== undefined) {
    return (
      <div className={'text-center'}>
        <LoadingButton
          type={'submit-button'}
          text={t('vehicle.create-mission-submit')}
          imagePath={'/theme/media/plus.svg'}
          loading={createMissionMutation.isPending}
          onClick={createMission}
        />
      </div>
    );
  }
}
